import React from 'react';
import './About.css'
import Piyush from '../About/Piyush.jpg'
import Zoom from 'react-reveal/Zoom';



const AboutMe = () => {
   
        return (
        <>
       <Zoom>
         <br />
         <br />
         <br />
         <br />
         <br />
            <h1 className='about text-center'>About Me</h1>
            
        <section className="text-gray-600 body-font overflow-hidden">
  <div className="container px-5 py-24 mx-auto">
    <div className="lg:w-4/5 mx-auto flex flex-wrap">

      <img alt="Piyush" className="lg:w-1/2 w-60 lg:h-auto h-64 object-cover object-center rounded" src={Piyush} />
     
      <div className="lg:w-1/2 w-full lg:pl-10 lg:py-6 mt-6 lg:mt-0">
      
        <h2 className="fuck text-gray-900 text-3xl title-font font-medium mb-5">Piyush Yadav</h2>
        
        <p className="leading-relaxed">I’m a programmer who codes, with dash Years of Experience I’ve not worked remotely on projects for leading brands, and startups.I care about creating world-class, and useful products that help people and make a difference.I can be as involved in your project as you need me to be, from the seed of the idea, creative direction, web development, graphic design, and even the back-end development.</p>
       
        <div className="text-center items-center mt-6">
      <a href='https://github.com/piyushyadav0191/resumepdf/blob/main/resume.pdf' target={'_blank'}>  <button>
  <span>Resume</span>
  <div className="liquid"></div>
</button>
</a>
</div>
       
      </div>
    </div>
  </div>
</section>
</Zoom>
        </>
            );
    
}

export default AboutMe;